import '../../src/js/components/_2_modal-video.js';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { setupSwiperPaginationWindow } from '../../src/js/includes/_1_swiper-pagination-window.js';

document.addEventListener('DOMContentLoaded', function() {
    ImageSlider();
});

function ImageSlider() {
    var swipers = document.querySelectorAll('.swiper.slider-images');

    swipers.forEach(function (swiper) {
        var wrapper = swiper.closest('.slider-images-wrap') || swiper.parentElement;
        var paginationEl = wrapper ? wrapper.querySelector('.swiper-pagination') : swiper.querySelector('.swiper-pagination');

        var swiperSlider = new Swiper(swiper, {
            modules: [Pagination],
            loop: false,
            speed: 500,
            slidesPerView: 1,
            spaceBetween: 32,
            pagination: {
                el: paginationEl,
                clickable: true,
            },
            keyboard: {
                enabled: true,
            }
        });

        setupSwiperPaginationWindow(swiperSlider, { visible: 5 });
    });
}